import '@fortawesome/fontawesome-pro/css/all.css'
import * as _ from 'underscore'

import './prizmdoc/normalize.min.css'
import './prizmdoc/viewer.scss'
import './prizmdoc/nextrequest.scss'
import '../../../../public/viewer-assets/css/viewercontrol.css'

import 'script-loader!./prizmdoc/jquery.hotkeys.min.js' // eslint-disable-line
import 'script-loader!../../../../public/viewer-assets/js/viewercontrol.js' // eslint-disable-line
import 'script-loader!../../../../public/viewer-assets/js/html5shiv.js' // eslint-disable-line
// Note: If there's an error with use-strict and numeric escapes, you likely need to
// re-escape things like \74 because import forces loading in strict mode. The instances
// of this seem to be unused anyway
import 'script-loader!./prizmdoc/viewerCustomizations.js' // eslint-disable-line
import './prizmdoc/viewer.js' // eslint-disable-line

window._ = _
